// LicenceAlerts.js — ATPL & MED TARİHLERİNİN UYARILARI (5 Eyl 2026)
//
// 🔑 Serkan: *"ir_valid_until / elp_valid_until / examiner_until zile düşsün."*
//
// 🔑 EŞİKLER BURADA TANIMLANMAZ: `trainingStatus` çağrılır — 60/30/15 tek
//    yerde (TrainingRules `ALERT_DAYS`). İkinci bir eşik listesi yazsaydık
//    yarın biri 60'ı 45 yapar, öbürü olduğu yerde kalırdı (İlke 3).
//
// 🔑 VERİ SÜRER, LİSTE DEĞİL: bir tarih girilmişse takip edilir, boşsa hiç
//    konuşulmaz. Böylece "LPC'niz IR'yi içeriyor mu" sorusunun cevabını
//    sistemin bilmesi gerekmez — IR tarihi girilirse izlenir, girilmezse
//    izlenmez. Aynısı kontrol pilotu yetkisi için de geçerli.
import { trainingStatus, medicalValidityMonths, addMonths, todayLocal } from './TrainingRules';

/** Her alan: hangi maddeden geliyor ve ekranda ne diye anılıyor. */
export const LISANS_ALANLARI = [
  { key:'ir_valid_until',  kod:'IR',       ad:'Instrument rating',
    ref:'SHT-FCL FCL.625(a)', not:'IR, 1 yıl boyunca geçerli olur.' },
  { key:'elp_valid_until', kod:'ELP',      ad:'Language proficiency',
    ref:'SHT-FCL FCL.055',
    not:'Dil yeterliliği olmadan lisansın imtiyazları kullanılamaz. Seviye 6 süresizdir.' },
  { key:'examiner_until',  kod:'EXAMINER', ad:'Examiner authorisation',
    ref:'SHT-FCL FCL.1025(a)', not:'Kontrol pilotluğu yetkisi 3 yıl süreyle geçerli olur.' },
];

/**
 * Bir pilotun ATPL & MED satırından uyarıya dönüşen kalemler.
 * @param {object} kayit  pilot_licence_med satırı (en yenisi)
 * @param {string} bugun  'YYYY-MM-DD'
 * @returns {Array} [{ key, kod, ad, ref, not, expires, st }]
 */
// ── SAĞLIK MUAYENESİNİN SON TARİHİ — TEK HESAP ────────────────────────
//
// 🔑 Serkan (6 Eyl 2026): *"Last exam date / due date — gelecek muayene için
//    son tarih, bu muayene tarihini girince otomatik gelmeli zaten."* ·
//    *"Yaşa ve limite göre."*
//
// 🔴 NEDEN AYRI FONKSİYON: aynı hesap üç yerde lazım — giriş formunda canlı
//    önizleme, pilot tablosunda sütun, ve zilde uyarı. Üç kopya yarın
//    ayrışırdı (İlke 3). Uyarı motoru da artık BUNU çağırıyor.
//
// 🔴 ÖLÇEMEDİĞİMİZİ SÖYLERİZ: doğum tarihi yoksa süre 12 mi 6 mı bilinemez;
//    tahmin etmek yerine `eksik` döner ve ekran bunu yazar (İlke 1).
/**
 * @returns {{ tarih: string|null, kaynak: string|null, ay: number|null, eksik: string|null }}
 */
export function medBitisi(kayit) {
  const k = kayit || {};
  const kisitlar = k.med_limitations || [];

  // TML her şeyi ezer: sertifikanın üstünde yazan tarih esastır.
  if (kisitlar.includes('TML')) {
    return k.med_valid_until
      ? { tarih: k.med_valid_until, kaynak: 'TML', ay: null, eksik: null }
      : { tarih: null, kaynak: 'TML', ay: null, eksik: 'TML expiry date not recorded' };
  }

  if (!k.med_exam_date) return { tarih:null, kaynak:null, ay:null, eksik:'exam date not recorded' };

  // Sınıf 2'nin kendi süreleri (yaşa göre 60/24/12 ay) HENÜZ KURULMADI;
  // Sınıf 1 kuralıyla hesaplayıp "Sınıf 2" demek yanlış olurdu.
  if (k.med_class !== 1) {
    return { tarih:null, kaynak:null, ay:null,
             eksik: k.med_class ? 'class 2 validity not implemented' : 'medical class not recorded' };
  }

  const ay = medicalValidityMonths(k.date_of_birth, k.med_exam_date);
  if (!ay) return { tarih:null, kaynak:'MED.A.045', ay:null, eksik:'date of birth not recorded' };
  return { tarih: addMonths(k.med_exam_date, ay), kaynak:'MED.A.045', ay, eksik:null };
}

export function lisansUyarilari(kayit, bugun = null) {
  if (!kayit) return [];
  const t = bugun || todayLocal();
  const out = [];

  LISANS_ALANLARI.forEach(a => {
    // ELP seviye 6 SÜRESİZDİR — tarih girilmiş olsa bile uyarı üretmez.
    if (a.key === 'elp_valid_until' && Number(kayit.elp_level) === 6) return;
    const tarih = kayit[a.key];
    if (!tarih) return;                       // girilmemişse SESSİZ (iddia yok)
    out.push({ ...a, expires: tarih, st: trainingStatus(tarih, t) });
  });

  // ── SAĞLIK: TML VARSA SERTİFİKANIN KENDİ BİTİŞİ ESASTIR ──────────
  //
  // 🔴 KUSUR DÜZELTMESİ (6 Eyl 2026). Buraya kadar geçerlilik YALNIZ muayene
  //    tarihi + yaştan türetiliyordu. AMC2 MED.B.001(b)(1) TML'yi şöyle
  //    tanımlıyor: *"The period of validity of the medical certificate is
  //    limited to the duration as shown on the medical certificate … Any
  //    period of validity remaining on the previous medical certificate is no
  //    longer valid."*  Yani TML'li bir sertifikada gerçek bitiş, hesapla
  //    bulunandan DAHA ERKEN olur. Eski hâliyle ekran, süresi çoktan dolmuş
  //    bir sağlığı "geçerli" gösterirdi — doğrulanmamışı doğrulanmış gibi
  //    göstermek (İlke 1). TML girildiyse HESAP HİÇ YAPILMAZ.
  // ── SAĞLIK SON TARİHİ — HESAP `medBitisi`DE (6 Eyl 2026) ─────────
  //
  // 🔴 Aynı hesap burada bir kez daha yazılmıştı; form ve tablo da onu
  //    istediği için ÜÇ KOPYA olacaktı. Tek fonksiyona indirildi (İlke 3).
  //    TML kuralı da orada: sertifikanın kendi tarihi hesabı EZER.
  const b = medBitisi(kayit);
  if (b.tarih) {
    const tml = b.kaynak === 'TML';
    out.push({ key:'med', kod:'MED',
               ad: tml ? 'Medical — TML (limited validity)' : `Medical class 1 (${b.ay} months)`,
               ref: tml ? 'AMC2 MED.B.001(b)(1)' : 'SHT-MED MED.A.045(a)',
               not: tml
                 ? 'TML: sağlık sertifikasının geçerliliği sertifikanın üstünde yazan süreyle '
                   + 'sınırlıdır. Bu kayıtta MED.A.045\'in 12/6 aylık hesabı UYGULANMAMIŞTIR; '
                   + 'sertifikanın kendi bitiş tarihi esas alınmıştır.'
                 : `Sınıf 1 sağlık sertifikaları 12 ay süre ile geçerli olacaktır; `
                   + `40 yaşına ulaşmış tek pilotlu ticari yolcu taşımasında veya 60 yaşına `
                   + `ulaşıldığında 6 aya düşer. Bu kayıtta ${b.ay} ay uygulandı.`,
               expires: b.tarih, st: trainingStatus(b.tarih, t) });
  } else if (b.kaynak === 'TML') {
    // İlke 2 — sessiz başarısızlık yok: TML var ama tarihi yoksa SUSMAYIZ.
    out.push({ key:'med', kod:'MED', ad:'Medical — TML recorded, expiry date MISSING',
               ref:'AMC2 MED.B.001(b)(1)',
               not:'Sertifikada TML var ama bitiş tarihi girilmemiş. Geçerlilik HESAPLANAMAZ — '
                 + 'hesapla türetilen tarih TML\'li sertifikada YANLIŞ olur.',
               // `st` bir NESNEDİR ({state, daysLeft}) — arayüz `st.state` okur.
               expires:null, st:{ state:'CRITICAL', daysLeft:null } });
  }

  return out;
}

/** Zile YALNIZ dikkat isteyenler düşer (VALID ve NO_EXPIRY düşmez). */
export function caniIlgilendiren(kayit, bugun = null) {
  return lisansUyarilari(kayit, bugun)
    .filter(x => ['NOTICE', 'WARNING', 'CRITICAL', 'EXPIRED'].includes(x.st.state));
}
